<template>
  <a v-if="isExt" :href="to" target="_blank" rel="noopener noreferrer" class="sidebar-link">
    <slot />
  </a>

  <router-link v-else :to="to" class="sidebar-link">
    <slot />
  </router-link>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  name: 'AppLink',
  props: {
    to: {
      type: String,
      required: true
    }
  },
  computed: {
    isExt() {
      return isExternal(this.to)
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-link {
  display: block;
  text-decoration: none;
  color: inherit;
}
</style>